import moment from 'moment';

export const formatTime = (timeInSeconds: number) => {
  if (!timeInSeconds) {
    return '0s';
  }

  return moment.utc(1000 * timeInSeconds).format('m[m] ss[s]');
};
